<rt-dialog-header
  [heading]="'wysiwyg.html-class-plugin.dialog_heading' | translate"
  [subheading]="'wysiwyg.html-class-plugin.dialog_subheading' | translate"
>
</rt-dialog-header>
<rt-dialog-body layout-horizontal>
  <rt-form-field>
    <rt-label>{{ 'wysiwyg.html-class-plugin.input_label' | translate }}</rt-label>
    <rt-input
      [autoFocus]="true"
      [formControl]="form"
      [hasClearButton]="true"
      [placeholder]="'wysiwyg.html-class-plugin.input_placeholder' | translate"
      (reset)="form.patchValue('')"
    ></rt-input>
  </rt-form-field>
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button (click)="cancel()" variant="plain">{{ 'wysiwyg.cancel' | translate }}</rt-button>
  <rt-button (click)="apply()" variant="primary">{{ 'wysiwyg.apply' | translate }}</rt-button>
</rt-dialog-footer>
